import useBeautyFilterStore from 'stores/beautyFilter/beautyFilterStore';

const useSticker = () => {
  const store = useBeautyFilterStore();
  const { selectedItem: selectedMenuItem } = store.menu;
  const { keys, table, selectedKey, setSelectedKey, resetSelectedKey } = store.sticker;

  const isTabVisible = selectedMenuItem.id === 'sticker';

  const isItemSelected = (key: string): boolean => selectedKey === key;

  return {
    keys,
    table,
    isTabVisible,
    isItemSelected,
    handleItemSelect: setSelectedKey,
    handleItemAllReset: resetSelectedKey,
  };
};

export default useSticker;
